import { Component, Input, Output, OnChanges, EventEmitter, ChangeDetectionStrategy } from '@angular/core';
import { DataObject } from '../../../interfaces/data-objects';
@Component({
  selector: 'iv-address-dropdown',
  templateUrl: './address-dropdown.component.html',
  styleUrls: ['./address-dropdown.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class AddressDropdownComponent implements OnChanges {

  /*
  * DONE: Implement this component on Represented Party Address, Bill to, etc.
  * or wherever we're displaying a list of customer's addresses
  * [x] Original Represented Party
  * [x] Represented Party Address
  * [x] Bill to
  * [x] Tax Info / India
  */

  @Input() possibleAddresses: any; // Customer's addresses & Customer's Info
  @Input() selectedCompanyName: string = ''; // Company's name
  @Input() representedAddress: any; // Sequence number
  @Input() displayAddressLabel = true;
  @Input() disabled = false;
  @Input() showNotFoundMessage = false;
  @Input() notFoundMessage = 'If you can not find the company that you are looking for, contact your admin or click on the link icon to create a new customer.';
  @Output() saveAddress: EventEmitter<any>;

  selectedAddress: DataObject = {};

  constructor() {
    this.saveAddress = new EventEmitter();
  }

  ngOnChanges(): void {
    this.getSelectedAddress(this.representedAddress);
  }

  addressChange(address: DataObject): void {
    if (address && address.address_seq_num) {
      this.getSelectedAddress(address.address_seq_num);
      this.saveAddress.emit(this.selectedAddress);
    }
  }

  getSelectedAddress(representedAddress: number): void {
    if (this.possibleAddresses?.addresses?.addresses) {
      if (!this.selectedCompanyName) {
        this.selectedCompanyName = this.possibleAddresses.name1 || null;
      }
      this.possibleAddresses = this.possibleAddresses?.addresses.addresses;
    }

    if (this.possibleAddresses && this.possibleAddresses.length > 0) {
      const filteredAddress = this.possibleAddresses.filter((address: DataObject) => `${address.address_seq_num}` === `${representedAddress}`);
      if (filteredAddress.length === 1) {
        this.selectedAddress = filteredAddress[0];
      } else {
        this.selectedAddress = this.possibleAddresses[0];
      }
      if (!this.selectedCompanyName) {
        this.selectedCompanyName = this.selectedAddress.name1 || null;
      }
    }
  }

  getStateInfo(address: DataObject): string {
    let state = '', county = '';
    if (address?.country && ['CHN', 'JPN', 'TWN'].includes(address?.country.trim())) {
      state = address?.state_descr?.trim() && !['NULL', 'None', ' '].includes(address?.state_descr) ? `${address?.state_descr},` : '';
      if (address?.county) {
        county = address?.county.trim() && !['NULL', 'None', ' '].includes(address?.county) ? `${address?.county},` : '';
      }
      return `${state}${county}`;
    } else {
      state = address?.state?.trim() && !['NULL', 'None', ' '].includes(address?.state) ? `${address?.state},` : '';
      return `${state}`;
    }
  }

}
